import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import {
  Card, CardContent, Grid, Button,
  Dialog, DialogContent, Typography
} from '@material-ui/core'

import UserMgmtUserMOD from '../UserManagement/UserMgmtUserMOD'
import { NotificationToast } from '../../tools'

/**
 * Returns org unit mgmt unit list form
 */
const OrgUnitMgmtUnitList = (props) => {
  const {
    setData, setUnitName, unitInfo,
    classes, hasChild,
    permissions, handleDeleteUnit, onTabSwap
  } = props

  const userRoles = useSelector(state => state.userRoles.userRoles)
  const userRoleSupervisors = useSelector(state => state.userListings.userRoleSupervisors)

  const [isEditing, setIsEditing] = useState(false)
  const [targetSupervisor, setTargetSupervisor] = useState({
    firstName: '',
    lastName: '',
    title: '',
    email: '',
    cell: '',
    roleID: '',
    supervisorID: '',
    units: []
  })

  const handleSuccessBackTrack = () => {
    setIsEditing(false)
    setTargetSupervisor({
      firstName: '',
      lastName: '',
      title: '',
      email: '',
      cell: '',
      roleID: '',
      supervisorID: '',
      units: []
    })
  }

  const handleSupervisorEdit = (e, userInfo) => {
    e.preventDefault()
    if (!userInfo || typeof userInfo !== 'object') { NotificationToast(true, 'Failed to edit supervisor!'); return false }

    const units = (() => {
      if (Array.isArray(userRoleSupervisors) && Boolean(userRoleSupervisors.length)) {
        const roleInfo = userRoleSupervisors.find(
          (roleSupInfo) => typeof roleSupInfo === 'object' && Boolean(roleSupInfo) && Boolean(roleSupInfo.roleID) && roleSupInfo.roleID === userInfo.roleID
        )

        if (typeof roleInfo !== 'object' || !roleInfo.roleID) { return [] }

        const supInfo = roleInfo.roleSupervisors.find(
          (supervisorInfo) => typeof supervisorInfo === 'object' && Boolean(supervisorInfo) && supervisorInfo.supervisorID === userInfo.supervisorID
        )

        if (typeof supInfo === 'object' && Boolean(supInfo) && Array.isArray(supInfo.units)) { return supInfo.units }
      }

      return []
    })()

    setTargetSupervisor({
      cell: userInfo.officePhone,
      email: userInfo.emailAddress,
      firstName: userInfo.firstName,
      lastName: userInfo.lastName,
      title: userInfo.jobTitle,
      roleName: userInfo.role,
      roleID: userInfo.roleID,
      supervisorID: userInfo.supervisorID,
      units
    })
    setIsEditing(true)
  }

  const renderUnitSupervisors = () => {
    const canEdit = (permissions.length ? permissions : []).findIndex((permission) => permission === 'supervisor-editor') !== -1

    const mappedSupervisors = unitInfo.unitSupervisors.map((userInfo, i) => {
      return (
        <Grid item container direction='column' key={`unit-supervisor-${i}`} sm={6}>
          <Card className='my-2 mx-1'>
            <CardContent>
              <Grid item container direction='row'>
                <Grid item container direction='column' sm={8} className='d-flex'>
                  <span className='font-weight-bold my-auto'>{userInfo.lastName}, {userInfo.firstName}</span>
                </Grid>
                <Grid item container direction='column' sm={4}>
                  <Button className={classes.greenBtn} variant='contained' disabled={!canEdit} onClick={(e) => handleSupervisorEdit(e, userInfo)}>Edit</Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      )
    })

    const actualSupervisors = []
    mappedSupervisors.forEach((supervisor, index, allSupervisors) => {
      if ((index + 1) % 2 === 0) {
        actualSupervisors.push(
          <Grid item container direction='row' key={`supervisor range: ${index - 1} - ${index + 1}`}>
            {allSupervisors.slice(index - 1, index + 1)}
          </Grid>
        )
      } else if (index === (allSupervisors.length - 1)) {
        actualSupervisors.push(
          <Grid item container direction='row' key={`supervisor range: ${index} - ${index + 1}`}>
            {allSupervisors.slice(index, index + 1)}
          </Grid>
        )
      }
    })

    return actualSupervisors
  }
  return (
    <>
      <Dialog open={isEditing} scroll='paper' disableBackdropClick disableEscapeKeyDown fullWidth maxWidth='md'>
        <DialogContent className={classes.editUserPaper}>
          <UserMgmtUserMOD
            firstName={targetSupervisor.firstName}
            lastName={targetSupervisor.lastName}
            jobTitle={targetSupervisor.title}
            emailAddress={targetSupervisor.email}
            cellPhone={targetSupervisor.cell}
            roleID={targetSupervisor.roleID}
            units={targetSupervisor.units}
            roleName={targetSupervisor.roleName}
            MODsupervisorID={targetSupervisor.supervisorID}
            onBackTrack={() => setIsEditing(false)}
            onSuccess={handleSuccessBackTrack}
            classes={classes}
            userRoles={userRoles}
            roles={userRoles.map((role) => {
              return {
                roleID: role.roleID,
                roleName: role.roleName
              }
            })}
            type='edit'
          />
        </DialogContent>
      </Dialog>

      <CardContent className='mt-2 ml-2'>
        <Grid item container direction='row' className='justify-content-end mt-2'>
          <Button
            className={`${classes.greenBtn} mr-3`}
            variant='contained'
            onClick={(e) => { e.preventDefault(); onTabSwap('edit'); setData(unitInfo) }}
          >
            Edit Unit Info
          </Button>
          <Button
            className={`${classes.saveBtn} mr-2`}
            variant='contained'
            onClick={(e) => { e.preventDefault(); onTabSwap('new'); setUnitName(unitInfo.unitName ? unitInfo.unitName : '') }}
          >
            Create Sub Unit
          </Button>
        </Grid>
        <Grid item container direction='row' className='mt-4'>
          <Grid item container direction='column' sm={5}>
            <Typography className='text-primary font-weight-bold'>Unit Name:</Typography>
          </Grid>
          <Grid item container direction='column' sm={5}>
            <Typography>{unitInfo.unitName ? unitInfo.unitName : 'N/A'}</Typography>
          </Grid>
        </Grid>
        <Grid item container direction='row' className='mt-4'>
          <Grid item container direction='column' sm={5}>
            <Typography className='text-primary font-weight-bold'>Unit Description:</Typography>
          </Grid>
          <Grid item container direction='column' sm={5}>
            <Typography>{unitInfo.unitDesc ? unitInfo.unitDesc : 'N/A'}</Typography>
          </Grid>
        </Grid>
        <Grid item container direction='row' className='mt-4'>
          <Grid item container direction='column' sm={5}>
            <Typography className='text-primary font-weight-bold'>Location:</Typography>
          </Grid>
          <Grid item container direction='column' sm={5}>
            {
              (unitInfo.address === null || unitInfo.address === '') &&
                (unitInfo.address2 === null || unitInfo.address2 === '') &&
                (unitInfo.city === null || unitInfo.city === '') &&
                (unitInfo.state === null || unitInfo.state === '') &&
                (unitInfo.postalCode === null || unitInfo.postalCode === '')
                ? (
                  <Typography>No Location Information Found</Typography>)
                : (
                  <>
                    <Typography>{unitInfo.address}</Typography>
                    <Typography>{unitInfo.address2}</Typography>
                    <Typography>
                      {unitInfo.city !== null ? `${unitInfo.city}, ` : ''}
                      {unitInfo.state !== null ? `${unitInfo.state} ` : ''}
                      {unitInfo.postalCode !== null ? `${unitInfo.postalCode}` : ''}
                    </Typography>
                  </>)
            }
          </Grid>
        </Grid>
        <Grid item container direction='row' className='mt-4'>
          <Grid item container direction='column' sm={5}>
            <Typography className='text-primary font-weight-bold'>Active Workstations:</Typography>
          </Grid>
          <Grid item container direction='column' sm={5}>
            <Typography>{unitInfo.activeWorkstations && unitInfo.maxUserCount ? `${unitInfo.activeWorkstations} / ${unitInfo.maxUserCount}` : 'N/A'}</Typography>
          </Grid>
        </Grid>
        <Grid item container direction='row' className='mt-4'>
          <Grid item container direction='column' sm={5}>
            <Typography className='text-primary font-weight-bold'>Total Captures:</Typography>
          </Grid>
          <Grid item container direction='column' sm={5}>
            <Typography>{unitInfo.captureCount ? unitInfo.captureCount : 'N/A'}</Typography>
          </Grid>
        </Grid>
        {unitInfo.unitSupervisors.length !== 0
          ? (
            <>
              <Grid item container direction='row' className='mt-4 mb-1'>
                <Grid item container direction='column' sm={5}>
                  <Typography className='text-primary font-weight-bold'>Supervisors:</Typography>
                </Grid>
              </Grid>
              <Grid item container direction='row' className={classes.supervisorContainer}>
                {renderUnitSupervisors()}
              </Grid>
            </>)
          : (
            <></>)}
        {unitInfo.isBaseUnit !== 1 && !hasChild && permissions.findIndex(permissionKey => permissionKey === 'unit-editor') !== -1 &&
          <Grid item container direction='row' className='mt-3' justify='flex-end'>
            <Button
              variant='contained'
              className={`${classes.deleteBtn} mr-2`}
              onClick={(e) => { e.preventDefault(); handleDeleteUnit(unitInfo.key) }}
            >
              Delete Unit
            </Button>
          </Grid>}
      </CardContent>
    </>
  )
}

export default OrgUnitMgmtUnitList
